/**
 * Task S: Platform admin → 官网设置 / Site settings and → Leads (the official Senvia POS marketing website).
 * One row per key: [key, English, 中文]. Malay falls back to English.
 */
const ROWS = [
  ["ts.nav.site", "Site settings", "官网设置"],
  ["ts.nav.leads", "Leads", "潜在客户"],
  ["ts.site.title", "Marketing website", "官网设置"],
  ["ts.site.sub", "The official Senvia POS website. Changes are live as soon as you save.", "Senvia POS 官方网站。保存后立即生效。"],
  ["ts.site.open", "Open website", "打开官网"],
  ["ts.site.save", "Save", "保存"],
  ["ts.site.saved", "Website settings saved", "官网设置已保存"],
  ["ts.site.reset", "Restore default text", "恢复默认文字"],
  ["ts.site.resetDone", "Default text restored", "已恢复默认文字"],
  ["ts.site.updated", "Last saved {at}", "上次保存 {at}"],
  ["ts.site.en", "English", "英文"],
  ["ts.site.zh", "中文", "中文"],
  ["ts.site.add", "Add", "添加"],
  ["ts.site.remove", "Remove", "删除"],
  ["ts.site.up", "Move up", "上移"],
  ["ts.site.empty", "Nothing here yet.", "暂无内容。"],
  ["ts.tab.hero", "Hero", "首屏"],
  ["ts.tab.sections", "Sections", "版块开关"],
  ["ts.tab.contact", "Contact & social", "联系方式与社交"],
  ["ts.tab.testimonials", "Testimonials", "客户评价"],
  ["ts.tab.logos", "Logos", "客户标志"],
  ["ts.tab.faq", "FAQ", "常见问题"],
  ["ts.tab.billingFaq", "Billing FAQ", "账单问题"],
  ["ts.tab.legal", "Legal", "法律条款"],
  ["ts.hero.eyebrow", "Small label above the headline", "标题上方的小标签"],
  ["ts.hero.headline", "Headline", "主标题"],
  ["ts.hero.sub", "Sub-copy", "副标题"],
  ["ts.sec.logos", "Logo strip", "客户标志栏"],
  ["ts.sec.screenshots", "App screenshots", "App 截图"],
  ["ts.sec.features", "Feature highlights", "功能亮点"],
  ["ts.sec.industries", "Industries", "行业"],
  ["ts.sec.steps", "How it works (3 steps)", "使用步骤（3 步）"],
  ["ts.sec.testimonials", "Testimonials", "客户评价"],
  ["ts.sec.pricing", "Pricing teaser", "价格简介"],
  ["ts.sec.faq", "FAQ", "常见问题"],
  ["ts.sec.finalCta", "Final call to action", "底部行动号召"],
  ["ts.sec.hint", "Switch off sections you don't want on the home page yet (e.g. testimonials until you have real ones).", "关闭暂时不想在首页显示的版块（例如在有真实评价之前先关闭客户评价）。"],
  ["ts.co.name", "Company name", "公司名称"],
  ["ts.co.email", "Contact e-mail", "联系邮箱"],
  ["ts.co.whatsapp", "WhatsApp number (with country code)", "WhatsApp 号码（含国家代码）"],
  ["ts.co.phone", "Phone", "电话"],
  ["ts.co.address", "Address", "地址"],
  ["ts.co.hours", "Support hours", "服务时间"],
  ["ts.co.demoUrl", "Demo booking link (e.g. Calendly)", "演示预约链接（例如 Calendly）"],
  ["ts.co.demoHint", "Empty = \"Book a demo\" opens the contact form.", "留空＝“预约演示”打开联系表单。"],
  ["ts.co.social", "Social links", "社交媒体链接"],
  ["ts.t.quote", "Quote", "评价内容"],
  ["ts.t.name", "Name", "姓名"],
  ["ts.t.role", "Role", "职位"],
  ["ts.t.business", "Business", "商家"],
  ["ts.t.placeholder", "The default testimonials are placeholders — replace them with real customers' words (with their permission) or switch the section off.", "默认评价只是示例——请换成真实顾客的话（需获其同意），或关闭此版块。"],
  ["ts.l.name", "Name", "名称"],
  ["ts.l.url", "Logo image URL (optional)", "标志图片网址（选填）"],
  ["ts.f.q", "Question", "问题"],
  ["ts.f.a", "Answer", "答案"],
  ["ts.legal.terms", "Terms of Service", "服务条款"],
  ["ts.legal.privacy", "Privacy Policy", "隐私政策"],
  ["ts.legal.refund", "Refund Policy", "退款政策"],
  ["ts.legal.updated", "Last updated (YYYY-MM-DD)", "最后更新（YYYY-MM-DD）"],
  ["ts.legal.hint", "Markdown: ## heading, - list, **bold**, [link](https://…). The default texts are templates — have them reviewed before you publish.", "Markdown：## 标题、- 列表、**粗体**、[链接](https://…)。默认文字只是模板，发布前请先审阅。"],
  ["ts.leads.title", "Leads", "潜在客户"],
  ["ts.leads.sub", "Contact and demo requests from the website.", "来自官网的咨询与演示预约。"],
  ["ts.leads.all", "All", "全部"],
  ["ts.leads.search", "Search name, e-mail or business", "搜索姓名、邮箱或店名"],
  ["ts.leads.none", "No leads yet. They appear here when someone sends the contact form.", "还没有潜在客户。有人提交联系表单后会显示在这里。"],
  ["ts.leads.when", "Received", "收到时间"],
  ["ts.leads.who", "Contact", "联系人"],
  ["ts.leads.business", "Business", "商家"],
  ["ts.leads.message", "Message", "留言"],
  ["ts.leads.status", "Status", "状态"],
  ["ts.leads.notes", "Notes", "备注"],
  ["ts.leads.saveNotes", "Save notes", "保存备注"],
  ["ts.leads.kind.demo", "Demo", "演示"],
  ["ts.leads.kind.contact", "Question", "咨询"],
  ["ts.leads.st.new", "New", "新"],
  ["ts.leads.st.contacted", "Contacted", "已联系"],
  ["ts.leads.st.won", "Won", "已成交"],
  ["ts.leads.st.lost", "Lost", "未成交"],
  ["ts.leads.st.spam", "Spam", "垃圾信息"],
  ["ts.leads.updated", "Lead updated", "已更新"],
  ["ts.leads.branches", "{n} branches", "{n} 家分店"],
] as const;

export type TsKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<TsKey, string>;

export const taskS = { en: col(1), zh: col(2), ms: col(1) };
